import { createRecord } from '@/entities/shared/record/create-record';
import type { Item } from '../schemas/item';
import { itemSchema } from '../schemas/item';

export async function createItem(data: Partial<Item>): Promise<string> {
  return createRecord('items', itemSchema, data);
}
